module.exports = __webpack_public_path__ + "static/slow_query-1fc8d4c3ec3cafccf30a8378d87eb7ce.png";